const initialState = {
  company: 'delta',
  documentType: '',
  includeExpired: false,
  isActiveCompanyAssociation: false,
};

export default initialState;
